/**
 * Clipboard helper with a graceful fallback for environments where the
 * async Clipboard API is unavailable (e.g. preview iframes, older browsers
 * served over insecure origins).
 *
 * Always resolves — never throws — so the caller can update UI state
 * unconditionally after the call.
 */
export const copyToClipboard = async (text) => {
  const fallback = () => {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;left:-9999px';
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    ta.remove();
  };
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
    } else {
      fallback();
    }
  } catch {
    fallback();
  }
};
